module.exports = __webpack_public_path__ + "img/App Modernization Services.48037633.svg";